import { useState, useEffect, useCallback } from 'react';
import apiJiraService from '../../services/jira.apiservice';
import { FluxText, FluxAccordion, FluxCircularProgress } from '@meltwater/flux-web-components-react';
import 'react-json-view-lite/dist/index.css';
import JiraDescription from './jiradescription';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, Paper, Box, Typography, Divider, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import JiraComments from "./jiracomments";
import Jirareporter from './jirareporter';
import JiraIntercom from './jiraintercom';
import JiraSearch from './jiraSearch';
import JiraExternalLinks from './jiraExternalLinks';
import styles from './jira.module.css';

const asyncRetry = require('async-retry');

const Jira = (props) => {
  const [status, setStatus] = useState("new");
  const [jiraerror, setJiraerror] = useState("");
  const [issuedata, setIssuedata] = useState(null);
  const { issueid } = useParams();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(true);
  const [isCommentsExpanded, setIsCommentsExpanded] = useState(true);
  const [isIntercomExpanded, setIsIntercomExpanded] = useState(true);

  useEffect(() => {
    // Set the title when the component mounts
    if (issuedata)
      document.title = `${issueid}-${issuedata.summary}`;
    else
      document.title = `${issueid}`;
    // Optionally, you can reset the title when the component unmounts
    return () => {
      document.title = 'GSD Support Admin';
    };
  }, [issuedata, issueid]);

  const updateportalavailable = (value) => {
    // Update portal availability logic
  };

  const fetchData = useCallback(async (issueid) => {
    let retryCount = 0;
    try {
      await asyncRetry(
        async (bail) => {
          const response = await apiJiraService.getIssue(issueid);

          if (response.status === 'ok') {
            console.log('Found issue ', response.data);
            setStatus("ok");
            setIssuedata(response.data);
            setJiraerror('Success'); // Update status on successful response
          } else {
            setStatus("error");
            console.log('Not Found issue ', response.status);
            if (response.statusCode === 429) {
              // Retry only for 429 status code
              console.log('Rate limit exceeded. Retrying... (Attempt:', retryCount + 1, ')');
              setJiraerror('Retrying'); // Update status during retry
              retryCount++;
              // Signal async-retry to retry
              bail(new Error('Rate limit exceeded'));
              return; // This line is essential to prevent further code execution in this iteration
            }
            setJiraerror(JSON.stringify(response.data.data)); // Update status during retry
          }
        },
        {
          retries: 3, // Number of retries
          minTimeout: 1000, // Minimum delay between retries in milliseconds
          maxTimeout: 5000, // Maximum delay between retries in milliseconds
          factor: 2, // Exponential backoff factor
        }
      );

      // Handle any post-retry logic or success-related tasks here

    } catch (error) {
      // Handle errors or retries exhausted

      setStatus("error");
      //setJiraerror(error.message);
      const mess = (error.response.data);

      setJiraerror(mess.data)
      // switch (error.status) {
      //   case 429:
      //     setJiraerror('Rate limit exceeded');
      //     break;
      //   case 403:
      //     setJiraerror('You do not have required permissions to view this ');
      //     break;
      //   case 404:
      //       setJiraerror('Project or Resource/ticket not found');
      //       break;
      //   default:
      //     setJiraerror(error.message)
      // }

    }
  }, []);

  useEffect(() => {
    // Make a GET request to fetch dashboard data using apiServiceDashboard
    const fetchDataEffect = async () => {
      if (issueid) {
        await fetchData(issueid);
      } else {
        setStatus("error");
        setJiraerror("No ticket number specified");
      }
    };

    fetchDataEffect();
  }, [fetchData, issueid]);

  console.log("Jiraerror ", jiraerror)

  return (
    <div className={styles.Jira} style={{ fontFamily: 'Inter, Roboto, Arial, sans-serif', background: '#f6f8fa', minHeight: '100vh', padding: '32px 0' }}>
      <div className={styles.divStyle}>
        {/* Top Bar Section (Group 1) */}
        {status === "new" &&
          <Paper elevation={0} style={{ borderRadius: 14, background: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,0.07)', marginLeft: '20px', marginRight: '20px', padding: 32, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
            <FluxCircularProgress indeterminate size="400">
              Searching for ticket {issueid}...
            </FluxCircularProgress>
          </Paper>
        }
        {issuedata && <>
          {/* Top Bar Section (Group 1) */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={3} px={2} py={1} style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', minHeight: 56, border: '2px solid #28bcbb', marginLeft: '20px', marginRight: '20px' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Box display="flex" gap={1}>
                <Button 
                  onClick={() => navigate(-1)}
                  startIcon={<ArrowBackIcon />}
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: '#1d9f9f',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#188182',
                    }
                  }}
                >
                  Back
                </Button>
                <Button
                  onClick={() => navigate('/jira')}
                  variant="contained"
                  size="small"
                  sx={{
                    minWidth: '40px',
                    padding: '6px',
                    backgroundColor: '#1d9f9f',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#188182',
                    }
                  }}
                > 
                  <HomeIcon fontSize="small" />
                </Button>
              </Box>
              <Typography variant="h5" style={{ fontWeight: 600, letterSpacing: 0.5, color: '#1a1a1a', marginLeft: '16px' }} className={styles.subheader}>{issuedata.issue}</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <JiraExternalLinks issuedata={issuedata} />
            </Box>
          </Box>

          {/* Main Content and Sidebar (Groups 2 & 3) */}
          <Grid container spacing={3} alignItems="stretch" sx={{ px: '20px' }}>
            {/* Main Content Section (Group 2) */}
            <Grid item xs={12} md={9} style={{ display: 'flex', flexDirection: 'column' }}>
                            <Paper elevation={3} style={{ 
                borderRadius: 14, 
                background: '#fff', 
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)', 
                padding: 32, 
                minHeight: '80vh', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'flex-start',
                border: '2px solid #28bcbb'
              }}>
                {/* Issue Data Summary Accordion */}
                <Box mb={2}>
                  <FluxAccordion
                    open={isExpanded}
                    onFlux-hide={() => setIsExpanded(false)}
                    onFlux-show={() => setIsExpanded(true)}>
                    <Typography slot="summary" variant="h6" className={styles.subheader} style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>{issuedata.summary}</Typography>
                    <FluxText appearance='subheader' style={{ marginTop: 8, fontWeight: 500 }}>Description</FluxText>
                    <Divider sx={{ my: 1 }} />
                    <JiraDescription data={issuedata.description} />
                    {issueid.toLowerCase().startsWith("kb") && <>
                      <Box mt={3}>
                        <Typography variant="subtitle1" fontWeight={600}>Steps to Reproduce</Typography>
                        <Divider sx={{ my: 1 }} />
                        <JiraDescription data={issuedata.stepstoreproduce} />
                      </Box>
                      <Box mt={3}>
                        <Typography variant="subtitle1" fontWeight={600}>Known Workarounds</Typography>
                        <Divider sx={{ my: 1 }} />
                        <JiraDescription data={issuedata.knownworkarounds} />
                      </Box>
                      <Box mt={3}>
                        <Typography variant="subtitle1" fontWeight={600}>Next Steps</Typography>
                        <Divider sx={{ my: 1 }} />
                        <JiraDescription data={issuedata.nextsteps} />
                      </Box>
                    </>}
                  </FluxAccordion>
                </Box>
                
                {/* Public Comments Accordion */}
                <Divider sx={{ my: 2 }} />
                <Box mb={2}>
                  <FluxAccordion
                    open={isCommentsExpanded}
                    onFlux-hide={() => setIsCommentsExpanded(false)}
                    onFlux-show={() => setIsCommentsExpanded(true)}>
                    <Typography slot="summary" variant="h6" className={styles.subheader} style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>Public Comments</Typography>
                    <JiraComments comments={issuedata.comments} />
                  </FluxAccordion>
                </Box>
                
                {/* Intercom Messages Accordion */}
                <Divider sx={{ my: 2 }} />
                <Box>
                  <FluxAccordion
                    open={isIntercomExpanded}
                    onFlux-hide={() => setIsIntercomExpanded(false)}
                    onFlux-show={() => setIsIntercomExpanded(true)}>
                    <Typography slot="summary" variant="h6" className={styles.subheader} style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>Intercom Messages</Typography>
                    <JiraIntercom intercom={issuedata.intercom} />
                  </FluxAccordion>
                </Box>
              </Paper>
            </Grid>
            {/* Sidebar Section (Group 3) */}
            <Grid item xs={12} md={3} style={{ display: 'flex', flexDirection: 'column' }}>
              <Paper elevation={2} style={{ borderRadius: 14, background: '#fafbfc', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', padding: 24, minHeight: '80vh', maxHeight: '80vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 24, border: '2px solid #28bcbb' }}>
                <Jirareporter updateportalavailable={updateportalavailable} issue={issuedata} />
                {/* You can add more metadata/info here as needed, e.g. status, priority, watchers, etc. */}
              </Paper>
            </Grid>
          </Grid>
        </>}
        {status === "error" &&
          <div style={{ fontFamily: 'Inter, Roboto, Arial, sans-serif', background: '#f6f8fa', minHeight: '100vh', padding: '32px 0' }}>
            <div className={styles.divStyle}>
              {/* Top Bar Section */}
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={3} px={2} py={1} style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', minHeight: 56, border: '2px solid #28bcbb', marginLeft: '20px', marginRight: '20px' }}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Button 
                    onClick={() => navigate(-1)}
                    startIcon={<ArrowBackIcon />}
                    variant="contained"
                    sx={{
                      backgroundColor: '#1d9f9f',
                      color: 'white',
                      boxShadow: '0 2px 6px rgba(29, 159, 159, 0.25)',
                      fontWeight: 600,
                      '&:hover': {
                        backgroundColor: '#188182',
                        boxShadow: '0 3px 8px rgba(29, 159, 159, 0.3)'
                      },
                      '&:active': {
                        backgroundColor: '#167172',
                        boxShadow: '0 1px 4px rgba(29, 159, 159, 0.2)'
                      }
                    }}
                  >
                    Back
                  </Button>
                  <Typography variant="h5" style={{ fontWeight: 600, letterSpacing: 0.5, color: '#1a1a1a', marginLeft: '16px' }}>
                    Error: {issueid}
                  </Typography>
                </Box>
              </Box>

              {/* Error Content */}
              <Paper 
                elevation={3}
                sx={{
                  background: '#fff',
                  borderRadius: 3,
                  p: 4,
                  mx: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
                  border: '2px solid #28bcbb'
                }}
              >
                <Typography variant="h4" color="error" fontWeight={600} mb={2}>
                  Ticket Not Found
                </Typography>
                <Typography variant="h6" color="text.secondary" mb={3}>
                  {jiraerror}
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={4}>
                  {issueid && issueid.toLowerCase().startsWith("mwtr") 
                    ? "Problems retrieving issue. Please wait a few minutes before retrying your request."
                    : issueid && !(issueid.startsWith('MWTR-') || issueid.toLowerCase().startsWith("kb") || issueid.toLowerCase().startsWith("premium"))
                    ? "This Jira Project is not supported. Please enter a valid ticket ID."
                    : "Please enter a valid Jira ticket number."
                  }
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={4}>
                  Contact Team Triton for more information
                </Typography>
                
                {/* Search Component for retry */}
                <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
                  <JiraSearch />
                </Box>
              </Paper>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default Jira;